import { render, staticRenderFns } from "./BusinessTotal.vue?vue&type=template&id=cd694eca&scoped=true&"
import script from "./BusinessTotal.vue?vue&type=script&lang=js&"
export * from "./BusinessTotal.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTotal.vue?vue&type=style&index=0&id=cd694eca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd694eca",
  null
  
)

export default component.exports